import Image from 'next/image';
import Link from 'next/link';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Article } from '@/shared/components/article';
import { ContactModal } from '@/shared/components/contact-modal';
import ThunderstormIcon from '@/shared/components/icons/thunderstorm-icon';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
import { APP_TITLE } from '@/shared/lib/seo/meta';
export const MainSpeakingClubs = () => {
  return <Article tag="main">
      <div className="grid grid-cols-1 items-center gap-x-5 sm:grid-cols-[1fr_minmax(200px,_40%)] sm:gap-x-10">
        <div className="mx-auto sm:mx-0">
          <div className="mb-10 sm:mb-5 sm:max-w-[620px]">
            <TextGradient text="Разговорные клубы" tag="h1" className="mb-6 text-center text-4xl xss:text-5xl sm:mb-4 sm:max-w-lg sm:text-left" />

            <p className="mx-auto text-center text-lg xss:max-w-md sm:mx-0 sm:max-w-xl sm:text-left sm:text-base">
              Не только про английский, но&nbsp;и&nbsp;про&nbsp;комьюнити!
            </p>
          </div>

          <div className="mb-8">
            <ul className="mx-auto max-w-sm space-y-3 text-sm sm:mx-0 sm:max-w-lg sm:space-y-2 sm:text-base md:max-w-xl">
              <li className="flex items-center gap-2">
                <ThunderstormIcon className="h-6 w-6 shrink-0 text-brand-accent-light" />
                <span>
                  Разговорные клубы подойдут для&nbsp;уровней A2-С1+. Наши встречи создают приближенную
                  к&nbsp;реальности атмосферу, где у&nbsp;всех разные уровни влядения языком
                </span>
              </li>

              <li className="flex items-center gap-2">
                <ThunderstormIcon className="h-6 w-6 shrink-0 text-brand-accent-light" />
                <span>Встречи проходят 2&nbsp;раза в&nbsp;неделю по&nbsp;60&nbsp;минут в&nbsp;мини-группах</span>
              </li>

              <li className="flex items-center gap-2">
                <ThunderstormIcon className="h-6 w-6 shrink-0 text-brand-accent-light" />
                <span>Занятия проводят русскоязычный преподаватель и&nbsp;носитель языка</span>
              </li>

              <li className="flex items-center gap-2">
                <ThunderstormIcon className="h-6 w-6 shrink-0 text-brand-accent-light" />
                <span>
                  Выкладываем расписание в&nbsp;
                  <Link href={process.env.NEXT_PUBLIC_TG_SCHOOL_URL ?? ''} target="_blank" rel="noopener noreferrer" className="text-brand-accent-normal hover:text-brand-accent-dark hover:underline dark:text-brand-accent-light dark:hover:text-brand-accent-normal">
                    ТГ канале
                  </Link>
                </span>
              </li>
            </ul>
          </div>

          <div className="flex justify-center sm:block">
            <ContactModal entryPoint="SPEAKING_CLUB">
              <Button variant="cta" className="px-6" aria-label="Записаться на бесплатную консультацию">
                Записаться
              </Button>
            </ContactModal>
          </div>
        </div>

        <div className="relative hidden items-center justify-end sm:flex 2xl:justify-center">
          <div className="min-h-[500px] max-w-full">
            <Image className="mx-auto hidden h-full w-full object-contain sm:inline-flex" fill src="/images/speaking-clubs/main.webp" alt={`Английский онлайн в${APP_TITLE}`} loading="lazy" />
          </div>

          <GradientBg className="z-0 hidden sm:block" type="circle" origin="center" size={300} />
        </div>
      </div>
    </Article>;
};